export async function notifyUser(
  notificationMessage = "Browser subscribed to Notifications",
) {
  if (!("Notification" in window)) {
    alert("Browser does not support notifications");
  } else if (Notification.permission === "granted") {
    new Notification(notificationMessage, { silent: true });
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission == "granted") {
        new Notification(notificationMessage, { silent: true });
      }
    });
  }

  return Notification.permission;
}
